export class IsotopeDefaultOption {
	static get() {
		return {
			itemSelector:       null,
			layoutMode:         'masonry',
			transitionDuration: 300,
			stagger:            30,
			percentPosition:    false,
			filter:             null,
			gutter: 10
		};
	}
}